import { api } from './axios';

export interface ScopePayload {
  unbounded: boolean;
  academicYearId: number | null;
  teacherClassSectionIds: number[];
  teacherSubjectIds: number[];
  teacherExamScheduleIds: number[];
}

export interface MeResponse {
  id: number;
  username: string;
  role: string;
  roleId: number;
  staffId: number | null;
  mustChangePassword: boolean;
  permissions: string[];
  scope?: ScopePayload;
}

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  expiresInSeconds: number;
  user: MeResponse;
}

export async function login(username: string, password: string) {
  const r = await api.post<AuthResponse>('/auth/login', { username, password });
  return r.data;
}

export async function refreshSession(refreshToken: string) {
  const r = await api.post<AuthResponse>('/auth/refresh', { refreshToken });
  return r.data;
}

export async function fetchMe() {
  const r = await api.get<MeResponse>('/auth/me');
  return r.data;
}

export async function changePassword(currentPassword: string, newPassword: string) {
  const r = await api.post<MeResponse>('/auth/change-password', { currentPassword, newPassword });
  return r.data;
}

export async function logout() {
  try { await api.post('/auth/logout'); } catch { /* ignore */ }
}
